export default (events, track) => store => next => action => {
  const eventCreators = events[action.type]
  if (eventCreators) {
    eventCreators.forEach(eventCreator => {
      const event = eventCreator(action, store.getState())
      if (event) {
        track(event)
      }
    })
  }

  return next(action)
}



/** WEBPACK FOOTER **
 ** ./src/middlewares/analytics/analytics-middleware.js
 **/